<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Receitas</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="recipes">Receitas</label>
                                    <select name="recipes[]" id="recipes" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(recipe, index) in recipes">
                                            {{ recipe.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setRecipes">Ordenar Receitas <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(recipe,index) in selected' :key="recipe.id" class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left" ></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="pull-left stages" :id="'stage' + recipe.id">{{ index + 1 }}. {{ recipe.name }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(recipe, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar</button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default{
        data: function(){
            return {
                recipes: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getRecipesArray: function(data){
                let array = [];
                $.each(data, function(index, value){
                    if(value.sort_by){
                        array.push(index);
                    }
                });
                return array;
            },
            getRecipes: function(){
                let self = this;
                let api  = self.$store.state.api + 'recipe?paginated=false';
                let recipes = $('#recipes');

                self.$http.get(api)
                    .then((response) => {
                        self.recipes = response.data.data;
                        self.ordered  = self.getRecipesArray(self.recipes);
                    })
                    .then(() => {
                        recipes.bootstrapDualListbox();
                        recipes.ready(function () {
                            recipes.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Receitas', 'error');
                    });
            },
            setRecipes: function(){
                const self   = this;
                let recipes = self.selected;

                $('#recipes').find(':selected').each(function(){
                    recipes.push(self.recipes[$(this).val()]);
                });

                self.selected = recipes;
                self.order = true;
            },
            save: function(){
                const self = this;

                postReorder(self, self.selected, "sort/recipe", self.getRecipesArray);
            },
            remove: function(recipe, index){
                const self = this;
                const api  = self.$store.state.api + 'recipe/' + recipe.id;

                let array  = [];
                $.each(self.selected, function(key, value){
                    if(index !== key){
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function(){
                window.location.reload();
            }
        },
        mounted: function(){
            this.getRecipes();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RecipeOrder/Index.vue